import React from 'react';
import { Modal, Table, InputNumber } from 'antd';

export const PosicionesModal = ({
  visible,
  currentArticulo,
  posicionesSeleccionadas,
  setPosicionesSeleccionadas,
  setModalVisible,
  setSelectedItems,
}) => {

  // Cambia cantidad a retirar en fila (posicion + lote + venc) usando key única
  const handleRowChange = (rowKey, cantidad) => {
    setPosicionesSeleccionadas(prev =>
      prev.map(r => (r.key === rowKey ? { ...r, cantidadRetirar: cantidad } : r))
    );
  };

  const handleModalOk = () => {
    // tomar sólo filas con retiro > 0 y agrupar por posición en "lotes"
    const filas = posicionesSeleccionadas.filter(f => Number(f.cantidadRetirar) > 0);

    const byPos = new Map();
    filas.forEach(f => {
      const list = byPos.get(f.posicion) || [];
      list.push({
        lote: f.lote ?? null,
        fechaVencimiento: f.fechaVencimiento ?? null,
        cantidad: f.cantidad,                 // disponible (informativo)
        cantidadRetirar: Number(f.cantidadRetirar || 0),
      });
      byPos.set(f.posicion, list);
    });

    const posiciones = Array.from(byPos.entries()).map(([posicion, lotes]) => ({ posicion, lotes }));

    const updatedArticulo = { ...currentArticulo, posiciones };

    setSelectedItems(prev => {
      const idx = prev.findIndex(it => it?.articulo?._id === updatedArticulo?.articulo?._id);
      if (idx >= 0) {
        const next = [...prev]; next[idx] = updatedArticulo; return next;
      }
      return [...prev, updatedArticulo];
    });

    setModalVisible(false);
  };

  return (
    <Modal
      title={`Posiciones del Artículo: ${currentArticulo?.nombreArticulo || ''}`}
      visible={visible}
      onOk={handleModalOk}
      onCancel={() => setModalVisible(false)}
      width={760}
    >
      <Table
        dataSource={posicionesSeleccionadas}
        rowKey="key"
        pagination={false}
        columns={[
          { title: 'Posición', dataIndex: 'posicion', key: 'posicion' },
          { title: 'Lote', dataIndex: 'lote', key: 'lote', render: v => v || '—' },
          {
            title: 'Vencimiento',
            dataIndex: 'fechaVencimiento',
            key: 'fechaVencimiento',
            render: v => (v ? new Date(v).toISOString().slice(0,10) : '—'),
          },
          { title: 'Cant. Disponible', dataIndex: 'cantidad', key: 'cantidad', render: (cantidad) => Number(cantidad).toFixed(2) },
          {
            title: 'Cant. a Retirar',
            key: 'cantidadRetirar',
            render: (_, record) => (
              <InputNumber
                min={0}
                max={record.cantidad}
                step={0.01}
                precision={2}
                value={record.cantidadRetirar}
                onChange={(val) => handleRowChange(record.key, val)}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};